module.exports = __webpack_public_path__ + "static/media/2.fcd21c22.gif";